import { useQuery } from '@tanstack/react-query';
import { getApiV1ScenariosByScenarioId } from '../api/generated/sdk.gen';
import { useAccessToken } from '../auth/AccessTokenContext';
import { queryKeys } from './queryKeys';

export const useFetchScenario = (scenarioId: string | undefined) => {
  const token = useAccessToken();

  return useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: queryKeys.scenario(scenarioId as string),
    queryFn: async () => {
      if (!scenarioId) return null;

      const response = await getApiV1ScenariosByScenarioId({
        path: {
          scenarioId,
        },
      });
      return response.data?.data || null;
    },
    enabled: !!token && !!scenarioId,
  });
};
